import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import "./layout.css"
import { Helmet } from "react-helmet"

export default ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet title={data.site.siteMetadata.title} />

        {children}

        <footer>
          <p className="gray">
            you're on: <Link to="/">mit dot katmh dot com</Link>
          </p>
          <p className="gray">to get in touch: katmh at mit dot edu</p>
        </footer>
      </>
    )}
  />
)
